module.exports = __webpack_public_path__ + "static/media/white.59c59de6.gif";